import { useEffect, useCallback } from "react";

const DEFAULT_MESSAGE =
  "Tienes cambios sin guardar. Si sales ahora, se perderán.";

export const useUnsavedChangesGuard = (isDirty, message = DEFAULT_MESSAGE) => {
  useEffect(() => {
    if (!isDirty) return undefined;

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isDirty]);

  const confirmIfDirty = useCallback(() => {
    if (!isDirty) return true;
    return window.confirm(message);
  }, [isDirty, message]);

  return { confirmIfDirty };
};
